import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import TicketDetail from "./TicketDetailAdmin2";
import "./Ticket2.css";

axios.defaults.withCredentials = true;

const TicketDetailAdmin = () => {
  const { id } = useParams(); 
  const [ticket, setTicket] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get("/ticketadmin", {
          params: { id },          
          withCredentials: true,
        });
        setTicket(res.data);
      } catch (err) {
        console.error(err);
        const status = err?.response?.status;
        if (status === 401) {
          navigate("/admin");
        } else if (status === 403) {
          setError("❌ คุณไม่มีสิทธิ์เข้าถึง ticket นี้");
        } else if (status === 404) {
          setError("❌ ไม่พบ ticket นี้");
        } else {
          setError("❌ เกิดข้อผิดพลาดในการโหลดข้อมูล");
        }
      } finally {
        setLoading(false);
      }
    })();
  }, [id, navigate]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;
  if (!ticket) return <p>❌ Ticket not found or invalid.</p>;

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString("th-TH", {
      timeZone: "Asia/Bangkok",
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return <TicketDetail ticket={ticket} formatDate={formatDate} />;
};

export default TicketDetailAdmin;
